import { render, staticRenderFns } from "./CardLink.vue?vue&type=template&id=a4439218&scoped=true"
import script from "./CardLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardLink.vue?vue&type=style&index=0&id=a4439218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4439218",
  null
  
)

export default component.exports